import { useTranslation } from "react-i18next";
import { withRouter } from "react-router-dom";

const ProfileNavbar = ({ history }) => {
  const { t } = useTranslation();
  return (
    <nav className="navbar bg-white align-center shadow-sm d-flex justify-content-between">
      <div onClick={() => history.push("/")}>
        <i
          className="fas fa-arrow-left"
          style={{ color: "#aaa", fontSize: "1.2rem" }}
        />
      </div>

      <div className="mb-0">
        <div style={{ fontSize: "1.1rem" }}>{t("Profile")}</div>
      </div>

      <span className="navbar-text d-flex align-center"></span>
    </nav>
  );
};

export default withRouter(ProfileNavbar);
